import { InputProps, SelectInput } from 'react-admin';

interface NumberRangeFilterInputProps extends InputProps {

}

const NumberRangeFilterInput = ({ source }: NumberRangeFilterInputProps) => {
  return (
    <SelectInput source={`${source}::eq`} choices={[
      { id: '', name: '', },
      { id: '1', name: 'yes', },
      { id: '0', name: 'no', },
    ]}/>
  );
};
export default NumberRangeFilterInput;
